module.exports = __webpack_public_path__ + "img/wb_logo-white.eeb04899.svg";